module.exports = __webpack_public_path__ + "img/ljyy.640ac1b0.png";